import { PopoverController } from '@ionic/angular';
import { Component, inject, output } from '@angular/core';
import { IonItem, IonList, IonRadio, IonRadioGroup } from '@ionic/angular/standalone';

import { ThemePreference, ThemeService } from '@app/services/theme.service';

@Component({
  selector: 'app-select-theme',
  templateUrl: './select-theme.component.html',
  styleUrls: ['./select-theme.component.scss'],
  imports: [IonRadioGroup, IonRadio, IonList, IonItem],
  providers: [PopoverController],
})
export class SelectThemeComponent {
  themeSrv = inject(ThemeService);
  popoverCtrl = inject(PopoverController);
  selected = output<ThemePreference>();

  protected selectItem(value: ThemePreference) {
    this.selected.emit(value);
    this.themeSrv.setTheme(value);
    this.popoverCtrl.dismiss();
  }
}
